import React, { useState } from "react";
import { Typography } from "antd";
import { Icon } from "@iconify/react";
import { ButtonComponent } from "@comps/components";
import SubmitStlcCase from "./SubmitStlcCase";

const { Text } = Typography;

/**
 * The case's STL delivery, on the case.
 *
 * Once the doctor has approved the plan, the case is finished by handing
 * the STL over, and completing it is blocked until that file exists —
 * which left the case detail page telling people to submit a file it
 * gave them no way to submit. The only route in was a "Submit STL file"
 * link on a list row, and only after an admin had formally asked for the
 * file.
 *
 * The file itself is not sent through the app: a case is an upper and a
 * lower arch and routinely runs to hundreds of megabytes, so it is
 * hosted where files that size belong — WeTransfer, Drive, a lab's own
 * host — and what is handed over here is the link to it. Submitting one
 * writes the case's file_link and posts it to the case chat, and that is
 * what opens up Complete case.
 */
const CaseStlDelivery = ({ caseData, onDelivered }) => {
  const [linkModal, setLinkModal] = useState(false);

  const delivered = Boolean(caseData.file_link);
  const isCompleted = caseData.status === 5;

  const onLinkSubmitted = () => {
    setLinkModal(false);
    onDelivered();
  };

  return (
    <>
      { delivered
        ? <div className="cd-stl cd-stl--done">
          <span className="cd-stl-mark"><Icon icon="tabler:cube" width={ 20 } /></span>
          <div className="cd-stl-text">
            <strong>STL file submitted</strong>
            <Text type="secondary">
              { isCompleted
                ? "The case was handed over with this file."
                : "This case can now be completed." }
            </Text>
          </div>
          <div className="cd-stl-actions">
            <a href={ caseData.file_link } target="_blank" rel="noopener noreferrer">
              <ButtonComponent icon={ <Icon icon="tabler:external-link" width={ 16 } /> }>
                Open STL file
              </ButtonComponent>
            </a>
            {/* A link can go stale or be pasted wrong, and until the case
                is closed it is still the technician's to correct. */}
            { !isCompleted &&
              <ButtonComponent onClick={ () => setLinkModal(true) }>Replace link</ButtonComponent>
            }
          </div>
        </div>

        : <div className="cd-stl">
          <span className="cd-stl-mark cd-stl-mark--waiting"><Icon icon="tabler:cube-off" width={ 20 } /></span>
          <div className="cd-stl-text">
            <strong>Waiting for the STL file</strong>
            <Text type="secondary">
              The plan is approved, so the case is finished by handing the file over.
              Upload it to WeTransfer or Drive and submit the link — the case can be
              completed once it is in.
            </Text>
          </div>
          <div className="cd-stl-actions">
            <ButtonComponent type="primary" onClick={ () => setLinkModal(true) }
              icon={ <Icon icon="tabler:link" width={ 16 } /> }>
              Submit STL file
            </ButtonComponent>
          </div>
        </div>
      }

      { linkModal &&
        <SubmitStlcCase
          caseid={ caseData.id }
          currentLink={ caseData.file_link }
          onSubmitted={ onLinkSubmitted }
          handleCancel={ () => setLinkModal(false) }
        />
      }
    </>
  );
};

export default CaseStlDelivery;
